(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // -------- Money formatting (Shopify standard) --------
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function defaultTo(num, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = (thousands == null) ? ',' : thousands;
      decimal = (decimal == null) ? '.' : decimal;
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsPart;
    }
    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = defaultTo(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' '); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function tmpl(str, map) {
    return String(str).replace(/\{(\w+)\}/g, function (_, k) { return (map[k] != null) ? map[k] : ''; });
  }

  // -------- Per-root controller --------
  function initRoot(root) {
    if (!root || root.__bybInit) return;
    root.__bybInit = true;

    var cfgEl = root.querySelector('[data-byb-config]');
    if (!cfgEl) return;
    var CFG = JSON.parse(cfgEl.textContent);
    var L = CFG.labels;
    // fallbacks for the templated labels (kept out of Liquid defaults because the
    // {q}/{n} braces trip Shopify's tag parser)
    L.titleProgress = L.titleProgress || '{q} selected · {n} more to unlock';
    L.titleOver = L.titleOver || 'Your bundle — {q} items';
    L.moreLabel = L.moreLabel || '+ {n} more';
    var money = function (c) { return formatMoney(c, CFG.moneyFormat).replace(/<[^>]*>/g, '').trim(); };

    // ----- the single pricing source of truth -----
    // The fixed offer drives the headline price AND the progress goal/milestones.
    var OFFER = String(CFG.offerTotals || '').split(',')
      .map(function (x) { return parseFloat(String(x).replace(/[^0-9.]/g, '')); })
      .filter(function (n) { return !isNaN(n) && n > 0; });
    var OFFER_EXTRA = parseFloat(String(CFG.offerExtra).replace(/[^0-9.]/g, '')) || 0;
    var GOAL = OFFER.length || 1;
    function bundlePriceCents(q) {
      if (q <= 0 || !OFFER.length) return 0;
      var amount;
      if (q <= OFFER.length) amount = OFFER[q - 1];
      else amount = OFFER[OFFER.length - 1] + (q - OFFER.length) * OFFER_EXTRA;
      return Math.round(amount * 100);
    }

    var grid = root.querySelector('[data-byb-grid]');
    var bar = root.querySelector('[data-byb-bar]');
    var barInner = root.querySelector('[data-byb-bar-inner]');
    var liveEl = root.querySelector('[data-byb-live]');
    var veil = root.querySelector('[data-byb-veil]');
    var modal = root.querySelector('[data-byb-modal]');
    var mTitle = root.querySelector('[data-byb-mtitle]');
    var mSub = root.querySelector('[data-byb-msub]');
    var mPrice = root.querySelector('[data-byb-mprice]');
    var mGallery = root.querySelector('[data-byb-mgallery]');
    var mOptions = root.querySelector('[data-byb-moptions]');
    var mConfirm = root.querySelector('[data-byb-mconfirm]');
    var mClose = root.querySelector('[data-byb-mclose]');
    var toast = root.querySelector('[data-byb-toast]');
    var toastText = root.querySelector('[data-byb-toast-text]');

    var STORE_KEY = 'byb:v2:' + CFG.sectionId;
    var STORE_MAX_AGE = 7 * 24 * 60 * 60 * 1000; // forget a stale bundle after 7 days

    // ----- product data map (id -> data) -----
    var PRODUCTS = {};
    function ingestCards(scope) {
      (scope || root).querySelectorAll('.card').forEach(function (card) {
        var id = card.getAttribute('data-id');
        if (!id || PRODUCTS[id]) return;
        var dataEl = card.querySelector('.byb-pdata');
        if (dataEl) { try { PRODUCTS[id] = JSON.parse(dataEl.textContent); } catch (e) {} }
      });
    }
    ingestCards();

    // ----- state: one unit per selected product -----
    // unit = { productId, variantId, size, price, compareAt, image, title }
    var state = { units: [] };

    function persist() {
      try { localStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), units: state.units })); } catch (e) {}
    }
    function restore() {
      try {
        var raw = localStorage.getItem(STORE_KEY);
        if (!raw) return;
        var data = JSON.parse(raw);
        var units = Array.isArray(data) ? data : (data && data.units);
        var saved = (data && data.t) || 0;
        if (!Array.isArray(units) || (saved && (Date.now() - saved) > STORE_MAX_AGE)) {
          localStorage.removeItem(STORE_KEY);
          return;
        }
        // keep only well-formed units (guards against schema drift / tampering)
        state.units = units.filter(function (u) {
          return u && u.variantId && typeof u.price === 'number' && typeof u.compareAt === 'number';
        });
      } catch (e) { state.units = []; }
    }

    function countOf(pid) { return state.units.some(function (u) { return String(u.productId) === String(pid); }) ? 1 : 0; }
    function indexOfProduct(pid) { return state.units.findIndex(function (u) { return String(u.productId) === String(pid); }); }

    // ----- grid buttons -----
    function refreshAddButtons() {
      root.querySelectorAll('.add-btn[data-add]').forEach(function (btn) {
        var id = btn.getAttribute('data-add');
        var on = !!countOf(id);
        btn.classList.toggle('in-set', on);
        btn.textContent = on ? L.remove : L.add;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    // ----- modal -----
    var modalProduct = null, selected = {}, matchedVariant = null, lastTrigger = null;

    // A value is offerable if some AVAILABLE variant carries it while matching the
    // shopper's other current selections (contextual — correct for multi-option products,
    // and reduces to plain stock for single-option products).
    function isValueAvailable(prod, optIndex, val) {
      var opts = prod.options || [];
      return prod.variants.some(function (v) {
        if (!v.available || v.options[optIndex] !== val) return false;
        return opts.every(function (_, j) {
          return j === optIndex || selected[j] == null || selected[j] === v.options[j];
        });
      });
    }
    function paintAvailability() {
      if (!modalProduct) return;
      (modalProduct.options || []).forEach(function (_, i) {
        mOptions.querySelectorAll('.size-chip[data-opt="' + i + '"]').forEach(function (chip) {
          var ok = isValueAvailable(modalProduct, i, chip.getAttribute('data-val'));
          var active = chip.classList.contains('active');
          chip.classList.toggle('sold', !ok);
          if (!ok && !active) { chip.setAttribute('disabled', ''); chip.setAttribute('aria-disabled', 'true'); }
          else { chip.removeAttribute('disabled'); chip.removeAttribute('aria-disabled'); }
        });
      });
    }

    function computeMatch() {
      if (!modalProduct) { matchedVariant = null; return; }
      var opts = modalProduct.options || [];
      matchedVariant = modalProduct.variants.find(function (v) {
        return opts.every(function (_, i) { return selected[i] === v.options[i]; });
      }) || null;
      mConfirm.disabled = !(matchedVariant && matchedVariant.available);
    }

    function renderModalOptions() {
      var prod = modalProduct;
      var html = '';
      (prod.options || []).forEach(function (optName, i) {
        var seen = [];
        prod.variants.forEach(function (v) { var val = v.options[i]; if (seen.indexOf(val) < 0) seen.push(val); });
        html += '<div class="opt-group"><div class="opt-name" id="byb-opt-' + i + '">' + escapeHtml(optName) + '</div>' +
          '<div class="sizes" role="group" aria-labelledby="byb-opt-' + i + '">';
        seen.forEach(function (val) {
          html += '<button type="button" class="size-chip' + (selected[i] === val ? ' active' : '') +
            '" data-opt="' + i + '" data-val="' + escapeAttr(val) + '">' + escapeHtml(val) + '</button>';
        });
        html += '</div></div>';
      });
      mOptions.innerHTML = html;
      paintAvailability();
    }

    function renderModalImages() {
      if (!mGallery || !modalProduct) return;
      var imgs = modalProduct.images || [];
      if (!imgs.length && modalProduct.featured_image) imgs = [{ src: modalProduct.featured_image, alt: modalProduct.title }];
      mGallery.innerHTML = imgs.map(function (img) {
        var src = typeof img === 'string' ? img : img.src;
        if (!src) return '';
        var alt = typeof img === 'string' ? modalProduct.title : (img.alt || modalProduct.title);
        return '<img src="' + escapeAttr(src) + '" alt="' + escapeAttr(alt) + '" loading="lazy">';
      }).join('');
    }

    function openModal(prod, triggerBtn) {
      modalProduct = prod; selected = {}; matchedVariant = null; lastTrigger = triggerBtn;
      mTitle.textContent = prod.title;
      mSub.textContent = (prod.options && prod.options.length === 1) ? prod.options[0] : '';
      var priceHtml = money(prod.price);
      if (prod.compare_at_price && prod.compare_at_price > prod.price) priceHtml += '<span class="mrp">' + money(prod.compare_at_price) + '</span>';
      mPrice.innerHTML = priceHtml;
      renderModalImages();
      renderModalOptions();
      mConfirm.disabled = true;

      // single-variant product → preselect everything
      if (prod.variants.length === 1) {
        (prod.options || []).forEach(function (_, i) { selected[i] = prod.variants[0].options[i]; });
        computeMatch();
      }

      veil.classList.add('open');
      document.addEventListener('keydown', onModalKey);
      var firstAvail = mOptions.querySelector('.size-chip:not(.sold)');
      setTimeout(function () { (firstAvail || mClose).focus(); }, 60);
    }
    function closeModal() {
      veil.classList.remove('open');
      document.removeEventListener('keydown', onModalKey);
      if (lastTrigger) setTimeout(function () { lastTrigger.focus(); }, 50);
    }
    function onModalKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    mOptions.addEventListener('click', function (e) {
      var chip = e.target.closest('.size-chip');
      if (!chip || chip.classList.contains('sold')) return;
      var i = +chip.getAttribute('data-opt');
      selected[i] = chip.getAttribute('data-val');
      mOptions.querySelectorAll('.size-chip[data-opt="' + i + '"]').forEach(function (c) { c.classList.remove('active'); });
      chip.classList.add('active');
      paintAvailability();
      computeMatch();
    });
    mClose.addEventListener('click', closeModal);
    veil.addEventListener('click', function (e) { if (e.target === veil) closeModal(); });
    mConfirm.addEventListener('click', function () {
      if (!matchedVariant || !matchedVariant.available) return;
      var prod = modalProduct;
      var sourceEl = root.querySelector('.card[data-id="' + prod.id + '"] .imgbox');
      var sizeLabel = (prod.options || []).map(function (_, i) { return selected[i]; }).join(' / ');
      closeModal();
      addUnit({
        productId: prod.id,
        variantId: matchedVariant.id,
        size: sizeLabel,
        price: matchedVariant.price,
        compareAt: (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) ? matchedVariant.compare_at_price : matchedVariant.price,
        image: prod.featured_image,
        title: prod.title
      }, sourceEl);
    });

    // ----- add / remove -----
    function addUnit(unit, sourceEl) {
      var idx = state.units.length;
      state.units.push(unit);
      persist(); renderBar(); refreshAddButtons();
      flyToSlot(unit, sourceEl, idx);
    }
    function removeUnit(idx) { state.units.splice(idx, 1); persist(); renderBar(); refreshAddButtons(); }
    function removeProduct(pid) {
      var i = indexOfProduct(pid);
      if (i >= 0) { state.units.splice(i, 1); persist(); renderBar(); refreshAddButtons(); }
    }

    // ----- fly to slot -----
    function flyToSlot(unit, sourceEl, unitIndex) {
      if (!sourceEl || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var target = unitIndex < 3 ? root.querySelector('.slot[data-index="' + unitIndex + '"]') : root.querySelector('.more-chip');
      if (!target) return;
      var sr = sourceEl.getBoundingClientRect(), tr = target.getBoundingClientRect();
      var fly = document.createElement('div');
      fly.className = 'byb-fly';
      fly.style.cssText = 'left:' + sr.left + 'px;top:' + sr.top + 'px;width:' + sr.width + 'px;height:' + sr.height + 'px;';
      if (unit.image) { var im = document.createElement('img'); im.src = unit.image; fly.appendChild(im); }
      root.appendChild(fly);
      var scale = tr.width / sr.width;
      var dx = (tr.left + tr.width / 2) - (sr.left + sr.width / 2);
      var dy = (tr.top + tr.height / 2) - (sr.top + sr.height / 2);
      requestAnimationFrame(function () { fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')'; fly.style.opacity = '0'; });
      setTimeout(function () { fly.remove(); }, 650);
    }

    // ----- hybrid pricing -----
    //   bundle price  = fixed offer structure (by quantity)
    //   MRP / savings = real selected products (compare_at_price, price fallback)
    function totals() {
      var q = state.units.length;
      var mrp = 0, sub = 0;
      state.units.forEach(function (u) { mrp += u.compareAt; sub += u.price; });
      var bundle = bundlePriceCents(q);
      var prepaid = CFG.enablePrepaid ? Math.round(bundle * (1 - (CFG.prepaidPercent / 100))) : bundle;
      var headline = prepaid;
      var save = Math.max(0, mrp - headline);
      var pct = mrp > 0 ? Math.round(save / mrp * 100) : 0;
      return { q: q, mrp: mrp, sub: sub, bundle: bundle, prepaid: prepaid, save: save, pct: pct };
    }

    // ----- bar -----
    var prevSave = 0, prevQ = 0, liveTimer = null, firstBarPaint = true;
    var easeOut = function (k) { return 1 - Math.pow(1 - k, 3); };
    function barFx(save, q) {
      var numEl = barInner.querySelector('.save-num');
      var pill = barInner.querySelector('[data-byb-savepill]');
      if (!numEl) { prevSave = 0; return; }
      if (pill && save !== prevSave) { pill.classList.add('bump'); setTimeout(function () { pill.classList.remove('bump'); }, 460); }
      if (q > prevQ && q <= GOAL) {
        var stops = barInner.querySelectorAll('.ts');
        var stop = stops[Math.min(q, stops.length) - 1];
        if (stop) { stop.classList.add('pulse'); setTimeout(function () { stop.classList.remove('pulse'); }, 620); }
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { numEl.textContent = money(save); prevSave = save; return; }
      var from = prevSave, to = save, dur = 520, t0 = null;
      function step(now) {
        if (t0 === null) t0 = now;
        var k = Math.min(1, (now - t0) / dur);
        numEl.textContent = money(Math.round(from + (to - from) * easeOut(k)));
        if (k < 1) requestAnimationFrame(step); else prevSave = to;
      }
      prevSave = to;
      requestAnimationFrame(step);
    }

    var AUTOHIDE = root.classList.contains('bar-autohide');
    function fitPadding() {
      if (!bar || !document.body.contains(bar)) return;
      requestAnimationFrame(function () {
        // bar is parked off-screen -> fall back to the stylesheet's small padding
        if (AUTOHIDE && state.units.length === 0) { root.style.paddingBottom = ''; return; }
        root.style.paddingBottom = (bar.offsetHeight + 32) + 'px';
      });
    }
    window.addEventListener('resize', fitPadding);

    function slotThumb(u) {
      if (u.image) return '<div class="fill"><img src="' + escapeAttr(u.image) + '" alt=""></div>';
      return '<div class="fill"></div>';
    }

    function renderBar() {
      var q = state.units.length;
      bar.classList.toggle('empty', q === 0);
      root.classList.toggle('has-bar', q > 0);
      // a bundle restored from localStorage must not slide in on load
      if (firstBarPaint) {
        firstBarPaint = false;
        bar.style.transition = 'none';
        requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.transition = ''; }); });
      }

      // zone 1: 3 slots + more chip
      var slotsHTML = '';
      for (var i = 0; i < 3; i++) {
        var u = state.units[i];
        if (u) {
          var label = u.title + (u.size ? ' · ' + u.size : '');
          slotsHTML += '<div class="slot filled" data-index="' + i + '" title="' + escapeAttr(label) + '">' +
            slotThumb(u) + (u.size ? '<span class="slot-size">' + escapeHtml(u.size) + '</span>' : '') +
            '<button type="button" class="rm" data-rm="' + i + '" aria-label="Remove ' + escapeAttr(label) + '">&times;</button></div>';
        } else {
          slotsHTML += '<div class="slot ghost" data-index="' + i + '" aria-hidden="true"></div>';
        }
      }
      var chipHTML = '';
      if (q > 3) chipHTML = '<span class="more-chip">' + tmpl(L.moreLabel, { n: q - 3 }) + '</span>';
      var zone1 = '<div class="slots">' + slotsHTML + chipHTML + '</div>';

      var t = totals();
      var fillPct = Math.min(q, GOAL) / GOAL * 100;

      // zone 2: status + track
      var title;
      if (q === 0) title = escapeHtml(L.titleEmpty);
      else if (q >= GOAL && q === GOAL) title = '<span class="tick">&#10003;</span>' + escapeHtml(L.titleUnlocked);
      else if (q > GOAL) title = escapeHtml(tmpl(L.titleOver, { q: q }));
      else title = escapeHtml(tmpl(L.titleProgress, { q: q, n: GOAL - q }));

      var stopsHTML = '';
      for (var st = 1; st <= GOAL; st++) {
        stopsHTML += '<span class="ts ' + (st === GOAL ? 'best ' : '') + (q >= st ? 'on' : '') + '">' +
          '<span class="ts-q">' + st + '</span>' + money(bundlePriceCents(st)) + '</span>';
      }
      var zone2 = '<div class="center-zone"><div class="zhead"><div class="msg-title">' + title + '</div></div>' +
        '<div class="track" data-complete="' + (q >= GOAL ? 1 : 0) + '"><div class="track-rail" style="--fill-pct:' + fillPct + '%"></div>' +
        '<div class="track-stops">' + stopsHTML + '</div></div></div>';

      // zone 3: price suite + CTA
      var dual, ctaCol;
      var priceMain = '', saveHTML = '', ctaCol;
      if (q === 0) {
        priceMain = '<div class="price-main is-empty"></div>';
        saveHTML = '<div class="ps-save is-empty"></div>';
        ctaCol = '<div class="cta-col"><button class="cta" data-byb-start>' + escapeHtml(L.start) + '<span class="arr">&rarr;</span></button></div>';
      } else {
        var mainLabel = CFG.enablePrepaid ? L.prepaidLabel : L.priceLabel;
        var secondary = '';
        if (CFG.enablePrepaid) {
          secondary = escapeHtml(L.codLabel) + ' ' + money(t.bundle);
          if (t.mrp > t.bundle) secondary += '<span class="ps-strike">' + money(t.mrp) + '</span>';
        } else if (t.mrp > t.prepaid) {
          secondary = '<span class="ps-strike">' + money(t.mrp) + '</span>';
        }
        priceMain = '<div class="price-main">' +
          '<span class="ps-label">' + escapeHtml(mainLabel) + '</span>' +
          '<span class="ps-now">' + money(t.prepaid) + '</span>' +
          (secondary ? '<span class="ps-cod">' + secondary + '</span>' : '') +
          '</div>';
        saveHTML = (t.save > 0)
          ? '<div class="ps-save" data-byb-savepill><span class="ps-save-k">' + escapeHtml(L.saveLabel) + '</span>' +
            '<span class="ps-save-v"><b class="save-num">' + money(t.save) + '</b></span>' +
            '<span class="ps-save-pct">' + t.pct + '% off</span></div>'
          : '<div class="ps-save is-empty"></div>';
        ctaCol = '<div class="cta-col"><button class="cta" data-byb-addcart><span class="cta-bag" aria-hidden="true"></span>' + escapeHtml(L.cta) + '<span class="arr">&rarr;</span></button>' +
          '<button class="clear-link" data-byb-clear>' + escapeHtml(L.clear) + '</button></div>';
      }

      barInner.innerHTML = zone1 + zone2 + priceMain + saveHTML + ctaCol;
      bindBar();
      barFx(t.save, q);
      fitPadding();
      // concise spoken status for screen-reader users (debounced so it's not chatty)
      if (liveEl) {
        clearTimeout(liveTimer);
        var spoken = q === 0 ? L.titleEmpty
          : q + ' ' + (q === 1 ? 'item' : 'items') + ' in bundle, ' + money(t.prepaid) +
            (t.save > 0 ? ', you save ' + money(t.save) : '');
        liveTimer = setTimeout(function () { liveEl.textContent = spoken; }, 350);
      }
      prevQ = q;
    }

    function bindBar() {
      barInner.querySelectorAll('[data-rm]').forEach(function (b) { b.addEventListener('click', function () { removeUnit(+b.getAttribute('data-rm')); }); });
      var startBtn = barInner.querySelector('[data-byb-start]');
      if (startBtn) startBtn.addEventListener('click', function () { var g = root.querySelector('.grid-wrap'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      var clearBtn = barInner.querySelector('[data-byb-clear]');
      if (clearBtn) clearBtn.addEventListener('click', function () { state.units = []; persist(); renderBar(); refreshAddButtons(); });
      var addCart = barInner.querySelector('[data-byb-addcart]');
      if (addCart) addCart.addEventListener('click', function () { submitBundle(addCart); });
    }

    // ----- add the whole bundle to the real cart -----
    function submitBundle(btn) {
      if (!state.units.length) return;
      btn.setAttribute('aria-busy', 'true');
      var items = state.units.map(function (u) { return { id: u.variantId, quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      }).then(function (added) {
        showToast(L.added);
        state.units = []; persist(); refreshAddButtons();
        document.dispatchEvent(new CustomEvent('byb:added', { detail: { items: added && added.items } }));
        if (CFG.afterAdd === 'checkout') { window.location.href = CFG.checkoutUrl || '/checkout'; }
        else if (CFG.afterAdd === 'cart') { window.location.href = CFG.cartUrl || '/cart'; }
        else if (CFG.afterAdd === 'drawer') { refreshCartUI(); renderBar(); openThemeCartDrawer(); }
        else { refreshCartUI(); renderBar(); }
      }).catch(function (err) {
        btn.removeAttribute('aria-busy');
        showToast((err && err.description) ? err.description : 'Could not add to cart');
      });
    }
    // Opens the theme's own cart drawer by firing the theme's own trigger, so we
    // never depend on a private drawer API. Falls back to the cart page.
    function openThemeCartDrawer() {
      var sel = CFG.drawerSelector || '#cart-drawer';
      var drawerId = sel.charAt(0) === '#' ? sel.slice(1) : null;
      // 1) the element the theme itself uses to open the drawer
      var opener = drawerId ? document.querySelector('[aria-controls="' + drawerId + '"]') : null;
      if (!opener) opener = document.querySelector('[aria-controls="cart-drawer"], [data-cart-drawer-toggle]');
      if (opener) { setTimeout(function () { opener.click(); }, 60); return; }
      // 2) a custom element exposing a conventional open method
      var drawer = document.querySelector(sel) || document.querySelector('cart-drawer');
      if (drawer) {
        var names = ['showDialog', 'show', 'open'];
        for (var i = 0; i < names.length; i++) {
          if (typeof drawer[names[i]] === 'function') { try { drawer[names[i]](); return; } catch (e) {} }
        }
      }
      // 3) nothing to open - send them to the cart page instead
      window.location.href = CFG.cartUrl || '/cart';
    }


    // Best-effort nudge for the theme's cart drawer / count bubble (used on "stay").
    function refreshCartUI() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var doc = document.documentElement;
          ['cart:refresh', 'cart:build', 'cart-updated'].forEach(function (name) {
            doc.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
          });
          if (window.Shopify && typeof Shopify.onCartUpdate === 'function') { try { Shopify.onCartUpdate(cart); } catch (e) {} }
        })
        .catch(function () {});
    }

    // ----- toast -----
    var toastTimer = null;
    function showToast(text) {
      toastText.textContent = text;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2400);
    }

    // ----- grid clicks -----
    if (grid) {
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('.add-btn[data-add]');
        if (!btn || btn.disabled) return;
        var id = btn.getAttribute('data-add');
        if (countOf(id)) { removeProduct(id); return; }
        var prod = PRODUCTS[id];
        if (!prod) return;
        // single-variant product → no size choice, add straight away
        if (prod.variants.length === 1) {
          var v0 = prod.variants[0];
          if (!v0.available) { showToast('Sold out'); return; }
          var src = root.querySelector('.card[data-id="' + id + '"] .imgbox');
          addUnit({
            productId: prod.id, variantId: v0.id, size: '',
            price: v0.price,
            compareAt: (v0.compare_at_price && v0.compare_at_price > v0.price) ? v0.compare_at_price : v0.price,
            image: prod.featured_image, title: prod.title
          }, src);
          return;
        }
        openModal(prod, btn);
      });
    }

    // ----- load more (AJAX append) -----
    root.addEventListener('click', function (e) {
      var lm = e.target.closest('.byb-loadmore');
      if (!lm) return;
      var url = lm.getAttribute('data-next');
      if (!url) return;
      lm.setAttribute('aria-busy', 'true');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-byb-grid]');
        if (newGrid && grid) {
          var frag = document.createDocumentFragment();
          newGrid.querySelectorAll('.card').forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
          grid.appendChild(frag);
          ingestCards();
          refreshAddButtons();
        }
        var newMore = doc.querySelector('.byb-loadmore');
        var wrap = lm.parentNode;
        if (newMore && newMore.getAttribute('data-next')) { lm.setAttribute('data-next', newMore.getAttribute('data-next')); lm.removeAttribute('aria-busy'); }
        else if (wrap) { wrap.parentNode.removeChild(wrap); }
      }).catch(function () { lm.removeAttribute('aria-busy'); });
    });

    // ----- helpers -----
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
    function escapeAttr(s) { return escapeHtml(s); }

    // ----- boot -----
    restore();
    renderBar();
    refreshAddButtons();
    setTimeout(function () { root.classList.remove('intro'); }, 1700);
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-byb]').forEach(initRoot); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor: re-init when this section is added/reloaded
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
